import styled from 'styled-components';

type TableBodyProps = {
  tableClassName?: string;
};

export const TableBody = styled.tbody.attrs<TableBodyProps>((props) => ({
  className: `${props.tableClassName}`,
}))<TableBodyProps>`
    & tr {
        height: 75px;
        cursor: pointer;
        border-bottom: thin solid;
        border-bottom-color: ${(props) => props.theme.palette.lightGray};
    }
    & tr:nth-child(odd){
      background-color: ${(props) => props.theme.palette.white};
    }
    & tr:nth-child(even){
      background-color: ${(props) => props.theme.palette.tableRowGray};
    }
    & tr:hover {
        background-color: ${(props) => props.theme.palette.lightGray};
        .mq-dashboard-activity-column {
          background-color:  ${(props) => props.theme.palette.lightGray};
    }
`;
